export enum ChartEnum {
   DAY = "DAY",
   MONTH = "MONTH",
   YEAR = "YEAR",
   APP = "APP",
   PROVINCE = "PROVINCE",
   NONE = "NONE",
}
